// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientBlock_root__1mvTk","header":"PatientBlock_header__ETPed","label":"PatientBlock_label__Zdimj","option":"PatientBlock_option__1ZY-L"};